// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".video-setup-window_e235 {\n  width: 50rem;\n  height: 37.5rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Teleop/AudioVideoSetupPopup/index.scss","index.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;ACCJ","file":"index.scss","sourcesContent":[".video-setup-window {\n    width: 50rem;\n    height: 37.5rem;\n}\n",".video-setup-window {\n  width: 50rem;\n  height: 37.5rem;\n}"]}]);
// Exports
exports.locals = {
	"video-setup-window": "video-setup-window_e235"
};
module.exports = exports;
